export default "__VITE_ASSET__BG6OehvY__"